(function () {
  function setup(root) {
    if (root.__stickyAtc) return;
    root.__stickyAtc = true;

    var sectionId = root.dataset.sectionId;
    var info = root.closest('product-info');
    if (!info) return;
    var btn = root.querySelector('[data-sticky-button]');
    var label = root.querySelector('[data-sticky-label]');
    var priceEl = root.querySelector('[data-sticky-price]');

    function mainBtn() { return document.getElementById('ProductSubmitButton-' + sectionId); }
    function form() { return info.querySelector('product-form') || info.querySelector('.product-form'); }

    function syncButton() {
      var m = mainBtn();
      if (!m) return;
      var t = m.querySelector('span');
      if (t && label) label.textContent = t.textContent.trim();
      btn.disabled = m.disabled || m.hasAttribute('disabled');
      btn.classList.toggle('loading', m.classList.contains('loading'));
    }

    function syncPrice() {
      var src = document.querySelector('#price-' + sectionId + ' .price');
      if (!src || !priceEl) return;
      var clone = src.cloneNode(true);
      clone.querySelectorAll('.visually-hidden, .badge, .unit-price, .price__badge-sale, .price__badge-sold-out').forEach(function (n) { n.remove(); });
      clone.removeAttribute('id');
      priceEl.innerHTML = '';
      priceEl.appendChild(clone);
    }

    function syncAll() { syncButton(); syncPrice(); }

    new MutationObserver(function (mutations) {
      var external = mutations.some(function (m) { return !root.contains(m.target); });
      if (external) syncAll();
    }).observe(info, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'class'] });

    btn.addEventListener('click', function () {
      var m = mainBtn();
      if (m && !m.disabled) m.click();
    });

    if (document.querySelector('[data-mobile-bottom-bar]')) root.classList.add('sticky-atc--above-bar');

    var target = form();
    if (target && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { root.hidden = e.isIntersecting; });
      }, { threshold: 0 }).observe(target);
    } else {
      root.hidden = false;
    }
    syncAll();
  }

  function init() { document.querySelectorAll('[data-sticky-atc]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();